module.exports = __webpack_public_path__ + "img/icon_home_fillin.ab1223e1.svg";